import * as t from 'io-ts';

/*
 * Runtime type.
 */

export const ROnlineTeammate = t.readonly(
  t.type({
    teammateId: t.number,
    connectionId: t.string,
  }),
  'onlineTeammate',
);

/*
 * Type.
 */

export interface OnlineTeammate extends t.TypeOf<typeof ROnlineTeammate> {}
